export enum CorrespondenceViewTaskFilter { 
        OutstandingTasks = 0,
        CompletedTasks = 1,
        AllTasks = 2,
        FutureTasks = 3,
}

